<template>
	<div>
		<p class="footer-content">
      <small>Copyright  2001-至今 益体康（北京）科技有限公司
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="padding-left: 10px;">京ICP备09007401号-12</a>
        <img src="../../assets/img/gongan.png" style="padding-left: 10px;">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802036751" target="_blank">京公网安备 11010802036751号</a>
      </small>
      <a href="https://etcomm-release.oss-cn-zhangjiakou.aliyuncs.com/pdfdownloader/pdfdownloader_beta1.0.0.3.exe" class="download">报告批量下载工具 v1.0.0.3</a>
    </p>
	</div>
</template>

<script>
export default {
	name: "FooterContent",
	data () {
		return {

		}
	},
	methods:{}
}
</script>

<style scoped>
.footer-content{
	background: #000;
	color:#fff;
	margin: 0 auto;
	width:100%;
	height: 50px;
	line-height: 50px;
	text-align: center;
}
.footer-content a{
  color: #ffffff;
}
.footer-content .download{
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/FooterContent.vue